import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@material-ui/core";
import { Warning } from "@material-ui/icons";
import moment from "moment";

const DuplicateCheckModal = ({ open, duplicates, onClose, onSelectDuplicate }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <Warning style={{ color: "#ff4d4f" }} />
          <span>Phát hiện giải pháp trùng lặp</span>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="error" style={{ marginBottom: 16 }}>
          Hệ thống phát hiện các giải pháp có thể trùng lặp. Vui lòng kiểm tra và chỉnh sửa nếu cần.
        </Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell style={{ width: 60 }}>STT</TableCell>
                <TableCell>Tên giải pháp</TableCell>
                <TableCell style={{ width: 150 }}>Số quyết định</TableCell>
                <TableCell style={{ width: 120 }}>Ngày công nhận</TableCell>
                <TableCell style={{ width: 100 }}>Hành động</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {duplicates && Array.isArray(duplicates) && duplicates.length > 0 ? (
                duplicates.map((record, index) => (
                  <TableRow key={record.solution?.id || index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{record.solution?.title || ""}</TableCell>
                    <TableCell>{record.solution?.decisionNumber || ""}</TableCell>
                    <TableCell>
                      {record.solution?.acceptedDay ? moment(record.solution.acceptedDay).format("DD/MM/YYYY") : ""}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => onSelectDuplicate(record)}
                      >
                        Sửa
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    Không có dữ liệu
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicateCheckModal;

